import { useEffect } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// Light-mode brand vars (used by the exact-class overrides at the top of index.css).
const VARMAP = {
  primary: "--brand-primary", secondary: "--brand-secondary", background: "--brand-bg",
  surface: "--brand-surface", text_primary: "--brand-text", text_secondary: "--brand-text2",
  border: "--brand-border", success: "--brand-success", warning: "--brand-warning", error: "--brand-error",
};

function hexToHsl(hex) {
  const h = hex.replace("#", "");
  const r = parseInt(h.substr(0, 2), 16) / 255, g = parseInt(h.substr(2, 2), 16) / 255, b = parseInt(h.substr(4, 2), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let hue = 0, s = 0; const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) hue = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) hue = (b - r) / d + 2;
    else hue = (r - g) / d + 4;
    hue /= 6;
  }
  return `${Math.round(hue * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

// Applies the active tenant's branding app-wide. Surfaces/text stay neutral-dark
// for legibility; the tenant's PRIMARY drives every accent (dark compat layer +
// shadcn --primary/--accent/--ring/--destructive) via --dk-accent + HSL.
export default function ThemeLoader() {
  const { user } = useAuth();
  useEffect(() => {
    const apply = (data) => {
      const b = data?.branding || {};
      const root = document.documentElement;
      Object.entries(VARMAP).forEach(([k, v]) => { if (b[k]) root.style.setProperty(v, b[k]); });
      if (b.primary) {
        root.style.setProperty("--dk-accent", b.primary);
        const hsl = hexToHsl(b.primary);
        ["--primary", "--accent", "--ring", "--destructive"].forEach((v) => root.style.setProperty(v, hsl));
      }
      if (data?.display_name) document.title = data.display_name;
      if (data?.logo) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
        link.href = data.logo;
      }
    };
    api.get(user ? "/tenant" : "/tenant/public").then((r) => apply(r.data)).catch(() => {});
  }, [user]);
  return null;
}
